import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@shared/components/ui/shadcn/tabs';
import { LeadTrackingTable, OrderVolumeChart } from './components';
import CustomerReport from './CustomerReport';

type MarketingTab = 'clientes' | 'leads' | 'pedidos';

const Marketing = () => {
  const { t } = useTranslation('marketingModule');
  const [activeTab, setActiveTab] = useState<MarketingTab>('clientes');

  return (
    <div className="px-6 pt-4 space-y-5" data-testid="marketing-report">
      {/* Mobile tabs */}
      <div className="lg:hidden">
        <Tabs value={activeTab} onValueChange={(value) => setActiveTab(value as MarketingTab)}>
          <TabsList className="flex w-full border-0 bg-card p-[2px] overflow-x-auto gap-1">
            <TabsTrigger value="clientes" className="whitespace-nowrap flex-shrink-0 flex-1">
              {t('tabs.customers', 'Clientes')}
            </TabsTrigger>
            <TabsTrigger value="leads" className="whitespace-nowrap flex-shrink-0 flex-1">
              {t('tabs.leads', 'Leads')}
            </TabsTrigger>
            <TabsTrigger value="pedidos" className="whitespace-nowrap flex-shrink-0 flex-1">
              {t('tabs.orders', 'Pedidos')}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="clientes" className="mt-4">
            <CustomerReport />
          </TabsContent>

          <TabsContent value="leads" className="mt-4">
            <LeadTrackingTable />
          </TabsContent>

          <TabsContent value="pedidos" className="mt-4">
            <OrderVolumeChart />
          </TabsContent>
        </Tabs>
      </div>

      {/* Desktop: métricas primero, listado compacto al final */}
      <div className="hidden lg:block space-y-5">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
          <LeadTrackingTable />
          <OrderVolumeChart />
        </div>
        <CustomerReport />
      </div>
    </div>
  );
};

export default Marketing;
